module.exports = __webpack_public_path__ + "img/petImage.14322970.svg";